import './styles/demo.css'
import { initReveal } from './reveal'
import { initNav } from './nav'
import { initAnalytics } from './analytics'
import { initBookingWidget } from './booking-widget'
import { initGuestChat } from './guest-chat'
import { initAdminApp } from './admin-app'

document.documentElement.dataset['env'] = import.meta.env.VITE_ENV_NAME

initAnalytics()
initNav()
initReveal()
initBookingWidget()
initGuestChat()
initAdminApp()
